export const DELAY = 'delay/DELAY';

export default { DELAY };
